import TopRatedMovies from './TopRatedMovies';

export default TopRatedMovies;
